'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regexp = exports.phone = exports.url = exports.numeric = exports.max = exports.min = exports.email = exports.regexValue = exports.required = undefined;

var _config = require('../config');

var required = exports.required = function required(val) {
  return !!val;
};
var regexValue = exports.regexValue = '^(?=.{0,255}$)[a-z0-9`’!\\^~#{&}\\?=\\$/\\|_%+-]+(\\.[a-z0-9`’!\\^~#{&}\\?=\\$/\\|_%+-]+)*@((([a-z0-9]+)|([a-z0-9]+[a-z0-9-]*[a-z0-9]+))\\.)+[a-z]{2,6}$';
var email = exports.email = function email(val) {
  return new RegExp(regexValue, 'i').test(val);
};
var min = exports.min = function min() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var minLen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return val.length >= minLen;
};
var max = exports.max = function max() {
  var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var maxLen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return val.length <= maxLen;
};
var numeric = exports.numeric = function numeric(val) {
  return !isNaN(parseFloat(val)) && isFinite(val);
};
var url = exports.url = function url(val) {
  return (/^((((ht|f)tps?):\/\/)|mailto:)[\w-]+(\.[\w-]+)+([\w-.,@?^=%&:/~+#]*[\w-@?^=%&/~+#])?$/i.test(val)
  );
};
var phone = exports.phone = function phone(val) {
  return _config.PHONE_NUMBER_CONFIG.some(function (phoneNumberPattern) {
    return phoneNumberPattern.test(val);
  });
};
var regexp = exports.regexp = function regexp(val, regex) {
  return val ? new RegExp(regex).test(val) : true;
};

exports.default = {
  required: required,
  email: email,
  min: min,
  max: max,
  numeric: numeric,
  url: url,
  phone: phone,
  regexp: regexp
};